import React, { PureComponent } from 'react';
import { isIOS, isAndroid } from '../common/Tools';
interface ProcessBarProps {
    onChange: (value: number) => void,
    max: number,
    value: number
}

class ProcessBar extends PureComponent<ProcessBarProps> {
    state = {
        isTouch: false,
        maxWidth: 0
    }

    public readprogbar: HTMLDivElement | null = null;
    public touchStart: React.TouchList | undefined = undefined;
    public borderLeftWidth = 0;
    public currentWidth = 0;

    componentDidMount() {
        const maxWidth = this.readprogbar!.clientWidth;
        this.setState({maxWidth: maxWidth});
    }
    public touch = (e: React.TouchEvent<HTMLAnchorElement>) => {
        // const { borderLeftWidth } = this.state;
        if (e.type === 'touchstart') {
            this.touchStart = e.changedTouches;
            this.borderLeftWidth = this.currentWidth;
            this.setState({isTouch: true});
        }
        else if ('touchend' === e.type) {
            // e.preventDefault();
            this.setState({isTouch: false});
            e.stopPropagation();
        }
        else {
            const touchOffset = e.changedTouches[0].pageX - this.touchStart![0].pageX;
            let width = this.borderLeftWidth + touchOffset;
            this.SetWidth(width);
        }
    }
    public click = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        // const { borderLeftWidth } = this.state;
        const borderLeftWidth = this.borderLeftWidth;
        let width = isIOS() || isAndroid() ? e.nativeEvent.offsetX : borderLeftWidth + e.nativeEvent.offsetX;
        console.log('offsetX:' + e.nativeEvent.offsetX, e.nativeEvent);
        console.log('borderLeftWidth:' + borderLeftWidth);
        this.SetWidth(width);
    }
    public SetWidth = (width: number) => {
        const maxWidth = this.readprogbar!.clientWidth;
        if (width > maxWidth) {
            width = maxWidth;
        }
        if (width < 0) {
            width = 0;
        }
        this.currentWidth = width;
        this.GetValue();
    }
    public GetValue = () => {
        const maxWidth = this.readprogbar!.clientWidth;
        const { onChange, max } = this.props;
        const value = this.currentWidth / maxWidth * max;
        onChange(value);
    }
    public render() {
        const { isTouch, maxWidth } = this.state;
        const { max, value } = this.props;
        // const _maxWidth = this.readprogbar === null ? 0 : this.readprogbar.clientWidth;
        const _borderLeftWidth = value / max * maxWidth;
        this.currentWidth = _borderLeftWidth;// 保存当前位置
        const thumbTouchStyle = isTouch ? {backgroundColor: 'white'} : {};
        return (
            <div ref={r => {
                this.readprogbar = r;
            }} className='read-prog-bar'>
                <div className="range" style={{width: maxWidth + 'px'}}>
                    {/* <a className="range-shadow" style={{left: '106.023px'}}></a> */}
                    <div className="range-track" style={{ borderLeftWidth: _borderLeftWidth + 'px' }} onClick={this.click}>
                        <a className="range-thumb" style={thumbTouchStyle} onTouchStart={this.touch} onTouchMove={this.touch} onTouchEnd={this.touch}/>
                    </div>
                </div>
                <input type="range" id="readProgRange" name="read-prog" min="0" max="484" defaultValue="0"></input>
            </div>
        );
    }
}

export default ProcessBar;
